import React, { forwardRef } from 'react';
import classnames from 'classnames';

interface ButtonProps {
  type?: 'button' | 'submit';
  variant?:
    | 'default'
    | 'success'
    | 'danger'
    | 'primary'
    | 'primary--v2'
    | 'outline-primary'
    | 'outline-primary-rounded'
    | 'danger'
    | 'info'
    | 'link'
    | 'hollow'
    | 'light-primary'
    | 'icon'
    | 'icon--v2'
    | 'clear'
    | 'external-black';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  children: any;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  tooltip?: any;
  title?: string;
  bold?: boolean;
  className?: string;
  id?: string;
  fullWidth?: boolean;
}

const Button = forwardRef(
  (
    {
      type = 'button',
      children,
      onClick,
      disabled,
      variant = 'default',
      size = 'md',
      tooltip,
      className,
      bold,
      fullWidth,
      ...rest
    }: ButtonProps,
    ref: any,
  ) => {
    const cn = classnames('btn', className, {
      [`btn-${variant}`]: true,
      [`btn-${size}`]: variant !== 'clear',
      'btn--bold': bold,
      'btn--not-clickable': !onClick,
      'btn--full-width': fullWidth,
    });

    return (
      <button
        type={type}
        className={cn}
        onClick={(event) => {
          if (!disabled && onClick) onClick(event);
        }}
        disabled={disabled}
        data-tip={tooltip}
        ref={ref}
        {...rest}
      >
        {children}
      </button>
    );
  },
);

export default Button;
